module.exports = __webpack_public_path__ + "static/media/creator.754a4388.jpg";